/**
 * Sidebar Module
 */

import { menus } from './data.js'
import { stat } from 'fs';

const state = {
    menus
}

const getters = {
    menus: (state, getters, rootState) => {
        const user = rootState.auth.user
        // filter admin menu item.
        if (!user.isAdmin) {
            const res = {}
            Object.keys(state.menus).forEach(key => {
                const menuItems = state.menus[key]
                if (key !== 'message.admin') {
                    if (key === 'message.stats') {
                        res[key] = menuItems.filter(i => {
                            if (user.isFormulaE) {
                                return i.title === 'message.reconcillation_fe'
                            } else {
                                return i.title === 'message.invoice'
                            }
                        })
                    } else {
                        res[key] = menuItems
                    }
                    
                }
            })
            return res
        }

        return state.menus
    }
}

const actions = {
    setActiveMenuGroup(context, payload) {
        context.commit('setActiveMenuGroupHandler', payload)
    },
    buildReportMenu (context, reports) {
        context.commit('setReportMenu', reports)
    }
}

const mutations = {
    setReportMenu (state, reports) {
        state.menus['message.reports'] = []
        for(const report of reports) {
            const reportMenuEntry = {
                action: 'zmdi-email',
                title: report.settings.caption['en'],// 'message.orderHistory',
                active: false,
                items: null,
                path: `/report/${report._id}`,
                exact: true
            }
            state.menus['message.reports'].push(reportMenuEntry)
        }
    },
    setActiveMenuGroupHandler(state, router) {
        let fullPath = router.history.current.fullPath;
        let path = fullPath.split('/');
        let matchedPath = '/' + path[2] + '/' + path[3];
        for (const category in state.menus) {
            for(const menuGroup in state.menus[category]) {
                if(state.menus[category][menuGroup].items !== null) {
                    for(const matched in state.menus[category][menuGroup].items){
                        if(state.menus[category][menuGroup].items[matched].path == matchedPath || state.menus[category][menuGroup].items[matched].path == fullPath ){
                           state.menus[category][menuGroup].active = true;
                        }
                    }
                }
            }
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}